export class header {
    constructor() {
        this.setupMobileMenu();
        this.headerScrolledTop();
        jQuery(document).on("mouseup", function (e) {
            var container = jQuery("#menu-main-navigation");
            //@ts-ignore
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                jQuery('#navicon').removeClass('open');
                jQuery('body').removeClass('show-nav');
                jQuery('.mobile-nav .expanded').removeClass('expanded');
            }
        });
        jQuery(document).on("mouseup", function (e) {
            var container = jQuery(".search_form_container");
            var search_icon = jQuery(".search_icon");
            //@ts-ignore
            if (!container.is(e.target) && container.has(e.target).length === 0 && !search_icon.is(e.target) && search_icon.has(e.target).length === 0) {

                jQuery(".search_form_container").slideUp();
            }
        });
        jQuery(document).on("scroll", function () {
            if (jQuery(".search_form_container").is(':visible')) {
                jQuery(".search_form_container").slideUp();
            }
        });

        let siteHeader = jQuery('.site-header');
        jQuery(".search_icon").on("click", function () {

            jQuery(".search_form_container").slideToggle(500, function () {
                if (jQuery(this).is(':visible')) {
                    jQuery(this).css('display', 'flex');
                }

            }
            );
        });

    }
    headerScrolledTop() {
        jQuery(window).on("resize scroll", function () {
            if (window.scrollY != 0) {
                jQuery('.site-header').addClass('page_scrolled');

            } else {
                jQuery('.site-header').removeClass('page_scrolled');

            }
        });
    }
    headerHeight;

    mobileMenu;

    setupMobileMenu() {
        //Mobile Menu
        jQuery('.mobile-nav .menu-item.menu-item-has-children').on('click', function () {
            jQuery(this).addClass('expanded');
        });

        jQuery('.mobile-nav .menu-item.menu-item-has-children').each(function () {
            let returnItem = document.createElement('li');
            returnItem.className = 'return-item menu-item';
            returnItem.innerHTML = this.getElementsByTagName('a')[0].outerHTML;
            this.getElementsByClassName('sub-menu')[0].prepend(returnItem);
        });

        jQuery('.mobile-nav').on('click', '.menu-item.return-item', function () {
            jQuery(this).closest('.menu-item-has-children.expanded').removeClass('expanded');
        });


        jQuery('#navicon').on('click', function () {

            if (this.classList.contains('open')) {
                jQuery('.mobile-nav .expanded').removeClass('expanded');
            }
        });
        jQuery('.close_mobile_nav').on('click', function () {
            jQuery('#navicon').removeClass('open');
            jQuery('body').removeClass('show-nav');
            jQuery('.mobile-nav .expanded').removeClass('expanded');
        });
    }

}